import { useToastContext } from "components/alert/ToastContext";
import saveAs from 'file-saver';
import Arquivo from "model/arquivo/Arquivo";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { FileUpload, FileUploadSelectEvent } from "primereact/fileupload";
import { Panel } from "primereact/panel";
import { useState } from "react";
import Lightbox from "react-image-lightbox";

type Props = {
    collapsed: boolean;
    onToggle: (e: { value: boolean }) => void;
    novosAnexos: any[];
    onChangeNovosAnexos: (anexos: any[]) => void;
    arquivos: Arquivo[];
    onChange: (arquivos: Arquivo[]) => void;
    accept?: string;
}

export default function AnexoPanel(props: Props) {

    const [photoIndex, setPhotoIndex] = useState<number>(0);
    const [photoOpen, setPhotoOpen] = useState<boolean>(false);
    const [imagensExibir, setImagensExibir] = useState<Arquivo[]>([]);

    const { msgAlerta } = useToastContext();

    function removerAnexoExistente(anexo: Arquivo) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente remover este anexo?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => confirmRemoverAnexoExistente(anexo),
        });
    }

    function onUploadAnexo(event: FileUploadSelectEvent) {
        try {
            if (event.files && event.files.length) {
                const anexosLocal = [...props.novosAnexos];
                for (let index = 0; index < event.files.length; index++) {
                    const file = event.files[index];
                    const idAnexo = new Date().getTime() * -1;
                    anexosLocal.push({ id: idAnexo, nome: file.name, data: null, file });
                }
                props.onChangeNovosAnexos(anexosLocal);
                event.files = [];
            }
        } catch (error) {
            console.error(error);
        }
    }

    function confirmRemoverAnexoExistente(anexo: Arquivo) {
        anexo.ativo = false;
        for (let i = 0; i < props.arquivos.length; i++) {
            if (props.arquivos[i].id === anexo.id) {
                props.arquivos[i] = anexo;
                confirmRemoverAnexo(anexo);
                break;
            }
        }

        props.onChange(props.arquivos);
    }

    function removerAnexo(anexo: any) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente remover este anexo?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => confirmRemoverAnexo(anexo),
        });
    }

    function confirmRemoverAnexo(anexo: any) {
        let anexosLocal = JSON.parse(JSON.stringify(props.novosAnexos));
        anexosLocal = anexosLocal.filter((o: any, i: any) => o.id !== anexo.id);
        props.onChangeNovosAnexos(anexosLocal);
    }

    function clickImagem(index: number, imagens: Arquivo[]) {
        setImagensExibir(imagens);
        setTimeout(() => {
            setPhotoIndex(index);
            setPhotoOpen(true);
        }, 100);
    }

    return (
        <Panel header={`Anexos/Imagens`} toggleable={true} collapsed={props.collapsed} onToggle={(e: any) => props.onToggle(e)}>
            {photoOpen && imagensExibir && imagensExibir.length > 0 && (
                <Lightbox
                    mainSrc={imagensExibir[photoIndex].url}
                    nextSrc={imagensExibir[(photoIndex + 1) % imagensExibir.length].url}
                    prevSrc={imagensExibir[(photoIndex + imagensExibir.length - 1) % imagensExibir.length].url}
                    onCloseRequest={() => setPhotoOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + imagensExibir.length - 1) % imagensExibir.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % imagensExibir.length)
                    }
                />
            )}
            <div className="col-sm-12">

                <div className="row">

                    <div className="col-sm-12">
                        <FileUpload mode="basic" name="anexoscontato" accept={props.accept ? props.accept : "*"} maxFileSize={20242880} multiple={true} onSelect={(event) => onUploadAnexo(event)}
                            auto={true} chooseLabel="Adicionar anexo" onValidationFail={(e) => msgAlerta("Não foi possível importar", "Tamanho máximo de 20Mb")} />
                    </div>
                    {props.novosAnexos && props.novosAnexos.length > 0 ?
                        <div className="col-sm-12">
                            <DataTable
                                header='Novos anexos'
                                value={props.novosAnexos}
                                emptyMessage='Nenhum anexo'
                            >
                                <Column field="nome" header="Nome" className='coluna-nome'></Column>
                                <Column
                                    style={{ width: 60 }}
                                    body={(rowData) => <>
                                        <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => removerAnexo(rowData)} />
                                    </>} />
                            </DataTable>
                        </div>
                        : null}

                    <div className="col-sm-12" style={{ marginTop: 8 }}>
                        <DataTable
                            header={null}
                            value={props.arquivos ? props.arquivos.filter(f => f.ativo) : []}
                            emptyMessage='Nenhum anexo'
                        >
                            <Column field="nome" header="Anexos"
                                className='coluna-nome'
                                body={(rowData) => rowData.id > 0 ? rowData.remover ?
                                    <span><s>{rowData.nome}</s></span>
                                    : <a
                                        style={{ color: '#3CA4FF', textDecoration: 'underline', textDecorationColor: '#3CA4FF', cursor: 'pointer' }}
                                        onClick={() => {
                                            fetch(rowData.url)
                                                .then(res => res.blob())
                                                .then(blob => saveAs(blob, rowData.nome))
                                                .catch(e => {
                                                    console.error(e)
                                                });
                                            return false;
                                        }}>{rowData.nome}</a> : rowData.nome}>
                            </Column>
                            <Column
                                style={{ width: 60 }}
                                body={(rowData) => <>
                                    {rowData.remover ? null :
                                        <Button type="button" icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => removerAnexoExistente(rowData)} />
                                    }
                                </>}>
                            </Column>
                        </DataTable>
                    </div>

                    {props.arquivos ?
                        <div className="col-sm-12" style={{ display: 'flex', marginTop: 8, overflow: 'auto' }}>
                            {
                                props.arquivos.filter(f => f.imagem && f.ativo).map((imagem, index) => {
                                    return <div key={`img${index}`} style={{ justifyContent: 'center', borderWidth: 1, borderColor: '#dadada', borderStyle: 'solid', marginLeft: 5, display: 'grid' }}>
                                        <a className='p-lightbox-image-target' style={{ marginLeft: 'auto', cursor: 'pointer', marginRight: 'auto', width: 128, textAlign: 'center' }} onClick={() => clickImagem(index, [...props.arquivos.filter(f => f.imagem && f.ativo)])}>
                                            <img style={{ maxHeight: 128, maxWidth: 128 }} src={imagem.url} title={imagem.nome} />
                                        </a>
                                        <Button type="button" label="Remover" className="ui-button-info" style={{ justifyContent: 'center' }} onClick={() => removerAnexoExistente(imagem)} />
                                    </div>
                                })
                            }
                        </div>
                        : null}

                </div>

            </div>
        </Panel>
    )
}


export function getFormData(label: string, data: any, anexos: any[], anexoLabel: string = 'files') {
    let formData = new FormData();
    formData.append(label, JSON.stringify(data));

    if (anexos && anexos.length > 0) {
        for (let i = 0; i < anexos.length; i++) {
            const file = anexos[i]?.file;
            if (file instanceof File) {
                formData.append(anexoLabel, file);
            } else {
                console.warn(`Anexo na posição ${i} não é um File válido:`, file);
            }
        }
    }

    return formData;
}